import NewPartialPayment from './NewPartialPayment';

export default NewPartialPayment;
